import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { CatalogState } from './catalog.reducer';
import { CatalogProductResponse } from '../../models/product-catalog.model';
import { ProductDetailResponse } from '../../models/product-detail.model';

export const selectCatalogState = createFeatureSelector<CatalogState>('catalog');

// --- Products ---
export const selectCatalogProducts = createSelector(selectCatalogState, (s): CatalogProductResponse[] => s.products);

// --- Product Details ---
export const selectAllProductDetails = createSelector(selectCatalogState, (s) => s.productDetails);

const selectProductDetailByCodeCache = new Map<string, MemoizedSelector<object, ProductDetailResponse | undefined>>();
export const selectProductDetailByCode = (code: string): MemoizedSelector<object, ProductDetailResponse | undefined> => {
  if (!selectProductDetailByCodeCache.has(code)) {
    selectProductDetailByCodeCache.set(
      code,
      createSelector(selectAllProductDetails, (details): ProductDetailResponse | undefined => details[code])
    );
  }
  return selectProductDetailByCodeCache.get(code)!;
};

// --- Tag Mapping ---
export const selectTagMapping = createSelector(selectCatalogState, (s) => s.tagMapping);

const selectCatalogProductByCodeCache = new Map<string, MemoizedSelector<object, CatalogProductResponse | undefined>>();
export const selectCatalogProductByCode = (code: string): MemoizedSelector<object, CatalogProductResponse | undefined> => {
  if (!selectCatalogProductByCodeCache.has(code)) {
    selectCatalogProductByCodeCache.set(
      code,
      createSelector(selectCatalogProducts, (products) => products.find(p => p.code === code))
    );
  }
  return selectCatalogProductByCodeCache.get(code)!;
};

// --- Loading ---
export const selectCatalogLoading = createSelector(
  selectCatalogState,
  (s) => s.productsLoading || s.tagMappingLoading,
);
